import { Fragment, Suspense, useState, useEffect } from "react";
import { LinearProgress } from "@material-ui/core";
import { Page } from "components";

// material-ui
import {
  Button,
  Grid,
  Typography,
  Card,
  TextField,
  IconButton,
  Box,
  Snackbar,
  CardMedia,
  CardContent,
} from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

// third party
import ServiciosUser from "utils/ServiciosUser";
import { makeStyles, useTheme } from "@material-ui/styles";
import { useForm, FormProvider } from "react-hook-form";
import { Autocomplete } from "@material-ui/lab";

import logodash from "assets/logo dashboard blanco.svg";
import logoti from "assets/logo ti blanco.svg";

// ============================|| AUTH ||============================ //

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(6, 2),
  },
  card: {
    width: theme.breakpoints.values.md,
    backgroundColor: "#2d3239",
    color: "white",
    maxWidth: "100%",
    overflow: "unset",
    display: "flex",
    position: "relative",
    borderRadius: "15px",
    "& > *": {
      flexGrow: 1,
      flexBasis: "50%",
      width: "50%",
    },
  },
  principal: {
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    position: "relative",
    height: "100vh",
  },
  content: {

    borderRadius: "10px",
    backgroundColor: "rgb(255,255,255)",
    color: "white",
    textAlign: "center",
    color: "#AEA16E",
  },
  media: {
    backgroundColor: "#2d3239",
    padding: "3%",
    color: theme.palette.white,
    justifyContent: "center",
    borderRadius: "10px",
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
    textAlign: "center",
    color: "#AEA16E",
  },
  fields: {
    margin: theme.spacing(-1),
    display: "flex",
    flexWrap: "wrap",
    "& > *": {
      flexGrow: 1,
      margin: theme.spacing(1),
    },
  },
  disabledButton: {
    backgroundColor: "#9c9c9c",
  },
  button: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    marginLeft: "50px",
    "@media(max-width:1288px)": {
      position: "absolute",
      marginRight: "100%",
    },
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  btnSubmit: {
    backgroundColor: "#2d3239",
  },
  // loginForm: {
  //   marginTop: theme.spacing(3),
  // },
  // person: {
  //   marginTop: theme.spacing(2),
  //   display: "flex",
  // },
  // avatar: {
  //   marginRight: theme.spacing(2),
  // },
}));

const Auth = ({ ...others }) => {
  const classes = useStyles();
  const [dominios, setDominios] = useState([]);
  const { register, getValues, handleSubmit, errors } = useForm();
  const [cargando, setCargando] = useState(false);
  const [mensaje, setMensaje] = useState({ open: false });
  const cerrarMensaje = () => setMensaje({ open: false });

  const registrarCorreoEmpresarial = (values) => {
    ServiciosUser.registrarCorreoEmpresarial(
      (estado, mensaje, data) => {
        console.log(mensaje);
        const status = data.status;
        // No ha verificado correo de empresarial
        if (status > 0 || status == -2) {
          setMensaje({ open: true, status: 1, value: mensaje });
          setTimeout(() => {
            localStorage.removeItem("user");
            window.location = "/"; // Redirigir después del tiempo de espera
          }, 4000);
        } else {
          setMensaje({ open: true, status: -1, value: mensaje });
        }
      },
      setCargando,
      { data: { id_usuario: localStorage.getItem("user"), ...getValues() } }
    );
  };

  useEffect(() => {
    ServiciosUser.dominios(
      (estado, mensaje, data) => {
        const datos = data.data;
        setDominios(datos.map((dominio) => dominio.name));
      },
      setCargando,
      { data: {} }
    );
  }, []);
  const regresarLogin = () => {
    localStorage.removeItem("user");
    window.location = "/";
  };
  return (
    <Page
      className={classes.root}
      title="Bienvenido"
      cargando={cargando}
      mensaje={{ ...mensaje, cerrar: (event) => setMensaje({ open: false }) }}
    >
      <Fragment>
        <main className={classes.principal}>
          <Suspense fallback={<LinearProgress />}>
            <Page className={classes.root} title="Bienvenido">
              <Card className={classes.card}>
                <CardMedia className={classes.media}>
                  <img
                    src={logodash}
                    width="100%"
                    style={{ height: "10vh", marginBottom: "100px" }}
                  />
                  <img src={logoti} width="100%" style={{ height: "10vh" }} />
                </CardMedia>
                <CardContent className={classes.content}>
                  <IconButton
                    className={classes.button}
                    onClick={regresarLogin}
                    title="Regresar"
                  >
                    <ArrowBackIcon />
                  </IconButton>
                  <Grid
                    container
                    spacing={3}
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                    style={{ marginTop: '12px', paddingBottom: '12px' }}
                  >
                    <Grid>
                      <Typography
                        gutterBottom
                        variant="h3"
                        style={{
                          fontFamily: "Trojan Bold",
                          color: "#AEA16E",
                          fontSize: "36px",
                        }}
                      >
                        Autenticación
                      </Typography>
                    </Grid>
                    <Grid item style={{ marginBottom: '12px' }}>
                      <Typography
                        variant="subtitle2"
                        style={{ paddingBottom: "10px", fontSize: "14px" }}
                      >
                        Ingresa tu cuenta corporativa. Ten en cuenta que a
                        partir de ahora tu usuario será tu correo electrónico,
                        es importante que el dominio ingresado sea uno de los
                        disponibles.
                      </Typography>
                    </Grid>
                  </Grid>
                  <hr sty />

                  <form
                    onSubmit={handleSubmit(
                      registrarCorreoEmpresarial,
                      (error) => {
                        console.log(error);
                      }
                    )}
                  >
                    <Grid
                      item
                      container
                      justifyContent="center"
                      alignItems="center"
                      style={{ marginTop: 15 }}
                      spacing={3}
                    >
                      <Grid item xs={12} md={6}>
                        <TextField
                          id="email"
                          name="email"
                          label="Correo electrónico"
                          placeholder="example@"
                          required
                          size="small"
                          fullWidth
                          variant="outlined"
                          inputRef={register({
                            required: {
                              value: true,
                              message: "Campo requerido",
                            },
                          })}
                          inputProps={{
                            pattern: "[A-Za-z0-9.]*",
                            title:
                              "Lo sentimos, solo se permiten letras (a-z), número (0-9) y puntos(.)",
                            style: {
                              color: "black"
                            }
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Autocomplete
                          id="dominio"
                          fullWidth
                          noOptionsText="Sin opciones"
                          options={dominios || []}
                          getOptionLabel={(option) => `@${option}`}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              name="dominio"
                              label="Dominio"
                              placeholder="ciudadmaderas.com"
                              variant="outlined"
                              autoComplete="off"
                              size="small"
                              InputProps={{
                                ...params.InputProps,
                                style: {
                                  color: "black", // Estilo para el texto dentro del input
                                },
                              }}
                              inputRef={register({
                                required: {
                                  value: true,
                                  message: "Campo requerido",
                                },
                              })}
                              required
                            />
                          )}
                        />
                      </Grid>
                      <Grid item xs={12} style={{ marginTop: 10 }}>
                        <Button
                          color="primary"
                          variant="contained"
                          type="submit"
                          fullWidth
                          style={{ boxShadow: "-2px 2px" }}
                          className={classes.btnSubmit}
                        >
                          Autenticar
                        </Button>
                      </Grid>
                    </Grid>
                  </form>
                  <br></br>
                  <br></br>
                </CardContent>
              </Card>
            </Page>
          </Suspense>
        </main>
      </Fragment>
    </Page>
  );
};

export default Auth;
